import CoreuiController from "../lib/coreui-controller"
import Collapse from "../coreui/collapse"

export default class CoreuiCollapseController extends CoreuiController {
  static Component = Collapse
  static values = { open: Boolean }

  mount() {
    super.mount()
    if (this.hasOpenValue) this.openValueChanged(this.openValue)
  }

  openValueChanged(open) {
    if (!this.instance) return
    open ? this.instance.show() : this.instance.hide()
  }
}
